module.exports = __webpack_public_path__ + "img/MCREDIT.1619c9d5.svg";